import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4b3335a4")

_pushScopeId("data-v-4b3335a4")
const _hoisted_1 = { id: "entire_app__transport_means" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "title_container" }, [
  /*#__PURE__*/_createVNode("svg", {
    id: "search-eye-line",
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createVNode("path", {
      id: "Path_51",
      "data-name": "Path 51",
      d: "M0,0H24V24H0Z",
      fill: "none"
    }),
    /*#__PURE__*/_createVNode("path", {
      id: "Path_52",
      "data-name": "Path 52",
      d: "M18.031,16.617,22.314,20.9,20.9,22.314l-4.282-4.283a9,9,0,1,1,1.414-1.414Zm-2.006-.742a7,7,0,1,0-.15.15l.15-.15Zm-3.847-8.7a2,2,0,1,0,2.646,2.646,4,4,0,1,1-2.646-2.646Z",
      fill: "#1d2329"
    })
  ]),
  /*#__PURE__*/_createVNode("h2", null, "Related ticket search results")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "transport_means_container" }, null, -1)
const _hoisted_4 = { class: "entire_transport_means__body_content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_router_view)
    ])
  ]))
})